var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,41.6c-0.3,0.3-0.8,0.6-1.4,0.6c-1.1,0-1.9-0.9-1.9-1.9V19.7c0-1.1,0.9-1.9,1.9-1.9c1.1,0,1.9,0.9,1.9,1.9 v20.5C31.5,40.8,31.3,41.3,31,41.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.2,31.3c-0.3,0.3-0.8,0.6-1.4,0.6H19.3c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h20.5 c1.1,0,1.9,0.9,1.9,1.9C41.8,30.5,41.6,31,41.2,31.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.6,8.8C17.9,8.8,8.4,18.3,8.4,30s9.5,21.2,21.2,21.2S50.7,41.6,50.7,30S41.3,8.8,29.6,8.8 M29.6,55 c-13.8,0-25-11.2-25-25s11.2-25,25-25s25,11.2,25,25S43.4,55,29.6,55"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpen);
export default __webpack_public_path__ + "static/media/ic_open.a6421304dcb4f4661c595e4550b6b4e8.svg";
export { ForwardRef as ReactComponent };